import type {
  _WorkbookApi,
  WorkbookApi,
} from '@mathflat/domain/@entities/(Content)/Workbook/api'
import type { WorkbookDomain } from '@mathflat/domain/@entities/(Content)/Workbook/domain'
import { Entity as WorkbookEntity } from '@mathflat/domain/@entities/(Content)/Workbook/dto'
import { upsertTimestampToUrl } from '@mathflat/shared/@common/utils/url/url'

import _workbookApi from '@/api/_workbook.api'
import { SchoolSubjectGrade } from '@/dto'
import type { CustomRequestConfigMeta } from '@/utils/axios/maxios'

import type Controller from './Controller'

/**
 * @deprecated
 */
export class WorkbookController implements Controller {
  adapter = {
    workbook: {
      from<T extends WorkbookDomain.Type>(
        response: _WorkbookApi.Response.GetWorkbook<T>,
      ): WorkbookEntity.WorkbookResponse<T> {
        if ('thumbnailImageUrl' in response && response.thumbnailImageUrl) {
          response.thumbnailImageUrl = upsertTimestampToUrl(response.thumbnailImageUrl)
        }
        return new WorkbookEntity.WorkbookResponse<T>(response)
      },
    },
  }

  fetchWorkbooks = async <
    T extends WorkbookDomain.Type = WorkbookDomain.Type,
    U extends 'GRADE' | 'CLASS' | 'STUDENT' | never = never,
  >(
    params?: _WorkbookApi.Request.GetWorkbook<T, U>,
    meta?: CustomRequestConfigMeta,
  ) => {
    const {
      data: {
        data: { content, last },
      },
    } = await _workbookApi.getWorkbooks<T, U>(params || ({} as any), meta)
    const workbookReponses = content.map(this.adapter.workbook.from)
    return { workbookReponses, last }
  }

  fetchWorkbookDetailInfo = async (workbookId: WorkbookEntity.Workbook['id']) => {
    const {
      data: { data },
    } = await _workbookApi.getWorkbookDetailInfo(workbookId)
    return { ...data, schoolGrade: new SchoolSubjectGrade(data) }
  }

  copyWorkbook = async (
    workbookId: WorkbookEntity.Workbook['id'],
    requestBody: WorkbookApi.CopyCustomWorkbook.Request,
  ) => {
    await _workbookApi.postWorkbookCopy(workbookId, requestBody)
  }
}

/**
 * @deprecated
 */
export const _workbookController = new WorkbookController()
